var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"ec-compare-button",class:{'active': _vm.active},attrs:{"href":"#","title":"Comparer ce vélo"},on:{"click":function($event){_vm.toggleComparison()}}},[_c('i',{staticClass:"ec-icon ec-icon-compare"})])}
var staticRenderFns = []

export { render, staticRenderFns }